var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-top",style:({ 'height': _vm.topHeightNum + 'px' })},[_c('div',{staticClass:"app-top-fixed",style:({ 'height': _vm.topHeightNum + 'px', 'background-color': _vm.colorTopBg })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb2f6ed","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/drTop/index.vue
// module id = null
// module chunks = 